import { CommandContribution } from '@patsnap/tahiti-core';
import { ExportPaperCommandContribution } from './export-paper-command-contribution';
import { RequestExportPaperOptionsService } from './services/request-export-paper-options-service';
import { createRequestExportPaperOptionsService } from './services/impls/request-export-paper-options-service';
import { ExportPaperService } from './services/export-paper-service';
import { ExportPaperServiceImpl } from './services/impls/export-paper-service';
import { ExportPaperRepositoryImpl } from './repositories/impls/export-paper-repository';
import { ExportPaperRepository } from './services/export-paper-repository';
import { ExportPaperApiImpl } from './apis/impls/export-paper-api';
import { GetExportPaperJobApi } from './apis/get-export-paper-job-api';
import { DataTypeActionContribution } from '@/domains/data-type-action/services/data-type-action-contribution';
import { ExportPaperActionContribution } from './export-paper-action-contribution';
export function exportPaperModule(bind) {
    bind(CommandContribution).to(ExportPaperCommandContribution);
    bind(DataTypeActionContribution).to(ExportPaperActionContribution);
    bind(RequestExportPaperOptionsService).toDynamicValue(createRequestExportPaperOptionsService());
    bind(ExportPaperService).to(ExportPaperServiceImpl);
    bind(ExportPaperRepository).to(ExportPaperRepositoryImpl);
    bind(ExportPaperApiImpl).toSelf();
    bind(GetExportPaperJobApi).toService(ExportPaperApiImpl);
}
